import { ReactNode } from 'react';

import { ModuleOfType, ModuleType } from './ModuleType';

type ContentModuleProps = {
  content: ReactNode;
  renderCondition: boolean;
};

type ContentModulePageModule = ModuleOfType<
  ModuleType.ContentModule,
  ContentModuleProps
>;

const ContentModule = ({ content, renderCondition }: ContentModuleProps) =>
  renderCondition ? <>{content}</> : null;

export { ContentModule };
export type { ContentModulePageModule, ContentModuleProps };
